import { Applicationcl } from 'src/app/Model/Applicationcl';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PagerService } from 'src/app/service/pager-service.service';
import { MasterConfigrationService } from 'src/app/service/MasterConfigrationService';
import { Router } from "@angular/router";
import { ExcelServicesService } from 'src/app/service/excel-services.service';
import { Observable } from 'rxjs';
import { PartyMaster } from 'src/app/Model/PartyMaster';
import { environment } from 'src/environments/environment';
import { AccountService } from 'src/app/service/AccountService';
import { AccLedgarMaster } from 'src/app/Model/Account/AccLedgarMaster';
import { isNullOrUndefined } from 'util';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { PdfGenerateService } from 'src/app/service/PdfGenerate.service';
import { AutoLogoutService } from 'src/app/service/auto-logout.service';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import htmlToPdfmake from 'html-to-pdfmake';
import { DatePipe } from '@angular/common';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-ledgerreport',
  templateUrl: './ledgerreport.component.html',
  styleUrls: [ './ledgerreport.component.css' ]
})
export class LedgerreportComponent implements OnInit {
  title = 'excel-upload-download';
  pager: any = {};
  pagedItems: any[];
  private userId: number;
  private items: any[];
  public excel: any[] = [];
  public LedgerData: any[] = [];
  public Acccode: string;
  public partylist: PartyMaster[];
  public CreditAmpunt: number;
  public DebitAmpunt: number;
  public ClosingAmpunt: number;
  public ClosingCRDr: string;
  public VoucherData: any[];
  public myControl = new FormControl();
  public filteredOptions: Observable<string[]>;
  public Partyoptions: string[] = [];
  public searchbyid: number;
  public SearchByValue: string;
  public ClosingCrDr: string;
  public fromdate: string;
  public todate: string;
  public DefaultDate: string;

  constructor (private pagerService: PagerService, private AutoLogoutService: AutoLogoutService, private oMasterConfigrationService: MasterConfigrationService, private router: Router,
    public oApplicationcl: Applicationcl, public excelService: ExcelServicesService, private datePipe: DatePipe,
    public oAccountService: AccountService, public oAccLedgarMaster: AccLedgarMaster, private PdfGenerateService: PdfGenerateService) {
    this.AutoLogoutService.CheckAuthentication();
    this.userId = parseInt(sessionStorage.getItem("userid"));
    this.Acccode = sessionStorage.getItem( "acccode");
    this.searchbyid = 1;
  }

  ngOnInit() {
    this.DefaultDate = new Date().toISOString().split('T')[ 0 ];
    this.fromdate = this.DefaultDate;
    this.todate = this.DefaultDate;
    this.filteredOptions = this.myControl.valueChanges.pipe(startWith(''), map(value => this._filter(value)));
    this.BindGrid();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.Partyoptions.filter(option => option.toLowerCase().includes(filterValue));
    //return this.partylist.filter(option => option.ACC_NAME.toLowerCase().includes(filterValue));
  }

  public FilterGrid(event: any) {
    if (this.searchbyid == 1) {
      this.items = this.LedgerData.filter(element => element.VDATE.toLowerCase().includes(this.SearchByValue.toLowerCase()));
      this.setPage(1, this.items);
    }
    else if (this.searchbyid == 2) {
      this.items = this.LedgerData.filter(element => element.V_NO.toLowerCase().includes(this.SearchByValue.toLowerCase()));
      this.setPage(1, this.items);
    }
    else if (this.searchbyid == 3) {
      this.items = this.LedgerData.filter(element => element.Type.toLowerCase().includes(this.SearchByValue.toLowerCase()));
      this.setPage(1, this.items);
    }
    else if (this.searchbyid == 4) {
      this.items = this.LedgerData.filter(element => element.CHEQUENO.toString().toLowerCase().includes(this.SearchByValue.toLowerCase()));
      this.setPage(1, this.items);
    }
    else {
      this.items = null;
      this.setPage(1, null);
    }
  }

  BindGrid ()
  {
    this.CreditAmpunt = 0;
    this.DebitAmpunt = 0;
    this.oApplicationcl.IsProgressBarEnable = true;
    this.oAccountService.GETLedgerDDetail( 2, this.Acccode ).subscribe(
      data =>
      {
        this.oApplicationcl.IsProgressBarEnable = false;
        this.oAccLedgarMaster = data;
        //console.log(this.oAccLedgarMaster);
        if ( isNullOrUndefined( this.oAccLedgarMaster.LEDGER_OPN_BALANCE ) )
        {
          this.oAccLedgarMaster.LEDGER_OPN_BALANCE = 0;
          this.oAccLedgarMaster.OPEN_BALANCE_CRDR = 'Cr';
        }
        this.excel = [];
        this.LedgerData = [];

        this.fromdate = new Date( '2018-01-01' ).toString();
        this.todate = new Date().toString();
        this.fromdate = this.datePipe.transform( this.fromdate, "yyyy-MM-dd" );
        this.todate = this.datePipe.transform( this.todate, "yyyy-MM-dd" );

        this.oAccountService.GETLedgerData( 2, this.oAccLedgarMaster.LEDGER_CODE, this.fromdate, this.todate ).subscribe(
          data =>
          {
            this.VoucherData = data;
            let BalAmt: number = 0;

            let vno: string;
            let icounter: number = 0;
            if ( this.VoucherData.length > 0 )
            {
              vno = this.VoucherData[ 0 ].V_NO;
            }
            //console.log(this.VoucherData);
            this.VoucherData.forEach( element =>
            {
              icounter += 1;
              if ( element.CrDr == "Cr" )
              {
                BalAmt = BalAmt - Number( element.CRAMOUNT );
                this.CreditAmpunt += Number( element.CRAMOUNT );
              } else
              {
                this.DebitAmpunt += Number( element.DRAMOUNT );
                BalAmt = BalAmt + Number( element.DRAMOUNT );
              }
              let arrgrid = {
                VNO: element.V_NO,
                VDATE: element.V_Date,
                Particulars: element.LEDGER_NAME,
                LedgerCode: element.LEDGER_CODE,
                Type: element.V_TYPE,
                DRAmount: element.DRAMOUNT,
                CRAmount: element.CRAMOUNT,
                CRDR: element.CrDr,
                BALANCE: BalAmt,
                NETSETT: element.NET_SETT,
                TDS: element.TDS_AMOUNT,
                DED: element.DED_AMOUNT,
                ONACCOUNT_AMT: element.ONACCOUNT_AMT,
                NARRATION: element.NARRATION,
                REF_TYPE: element.REF_TYPE,
                REF_NO: element.REF_NO,
                CHEQUENO: element.V_CHEQUENO
              };
              let arrexcel = {
                VNO: element.V_NO,
                VDATE: ( icounter == 1 ? '--' : element.V_Date.split( 'T' )[ 0 ] ),
                RefNo: element.REF_NO,
                Particulars: element.LEDGER_NAME,
                Type: element.V_TYPE,
                DRAmount: element.DRAMOUNT,
                CRAmount: element.CRAMOUNT,
                CRDR: element.CrDr,
                BALANCE: BalAmt,
                NETSETT: element.NET_SETT,
                TDS: element.TDS_AMOUNT,
                DED: element.DED_AMOUNT,
                CHEQUENO: element.V_CHEQUENO,
                NARRATION: element.NARRATION
              };
              this.LedgerData.push( arrgrid );
              this.excel.push( arrexcel );
            } );

            let arrExcel = {
              VNO: '--',
              VDATE: '--',
              RefNo: '--',
              Particulars: '--',
              Type: '--',
              DRAmount: this.DebitAmpunt,
              CRAmount: this.CreditAmpunt,
              CRDR: this.ClosingCRDr,
              BALANCE: ( this.DebitAmpunt - this.CreditAmpunt ),
              NETSETT: '--',
              TDS: '--',
              DED: '--',
              CHEQUENO: '--',
              NARRATION: '--'
            };

            if ( ( this.DebitAmpunt - this.CreditAmpunt ) > 0 )
            {
              this.ClosingCrDr = "Dr";
            }
            else
            {
              this.ClosingCRDr = "Cr";
            }

            this.excel.push( arrExcel );
            this.items = null;
            this.setPage( 1, null );
          } );
      } );
  }

  setPage(page: number, item: any) {
    if (this.items != null && this.items.length > 0) {
      this.pager = this.pagerService.getPager(this.items.length, page, 100);
      this.pagedItems = this.items.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pager = this.pagerService.getPager(this.LedgerData.length, page, 100);
      this.pagedItems = this.LedgerData.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }


  ExportTOExcel() {
    if (this.excel.length > 0) {

      this.excelService.exportAsExcelFile(this.excel, 'PartyLedger');

    }
    else {
     alert( "No record for export to excel"  );
    }
  }

  public SavePDF() {
    if (this.excel.length <= 0) {
      alert( "No record for export to excel" );
      return;
    }

    let icounter: number = 0;
    let stringarr = '<div style="text-align: center; font-size:15px;"><b>AASH LOGISTICS PVT LTD</b></div>'
      + '<div style="text-align: center;font-size:11px;">SIMPLY YOUR WAY...</div>'
      + '<div style="text-align: center;padding-top:10px;">D-62, SECTOR-10 NOIDA,201301,UTTAR PRADESH</div>'
      + '<div style="text-align: center;">PH: 9999161913,  HTTP://WWW.AASHLOGISTICS.COM, MO: 9999161913</div>'
      + '<div style="text-align: center;font-size:12px;padding-top:10px;"><b>Ledger Report</b></div>'
      + ' <div style = "font-size: 14px; text-align: left;" >Party Name: <b>' + this.oAccLedgarMaster.LEDGER_NAME + ' <b> </div>';
    stringarr += '<table style="font-size: 7px;"><tr>'
      + '<td> SNo </td>'
      + '<td> Voucher Date</td>'
      + '<td> Ref. No</td>'
      + '<td> Particulars</td>'
      //+ '<td> Operation Type</td>'
      + '<td> Credit Amount </td>'
      + '<td> Debit Amount </td>'
      + '<td> DR/CR </td>'
      + '<td> Balance </td>'
      + '<td> NET SETT </td>'
      + '<td> TDS </td>'
      + '<td> DED</td>'
      + '<td> Narration </td>';

    this.LedgerData.forEach(element => {
      stringarr += '<tr><td >' + (icounter + 1)
        + '</td><td>' + (icounter == 0 ? '--' : element.VDATE.split('T')[ 0 ])
        + '</td><td>' + element.REF_NO
        + '</td><td>' + element.Particulars
        // + '</td><td>' + element.Type
        + '</td><td>' + element.CRAmount
        + '</td><td>' + element.DRAmount
        + '</td><td>' + element.CRDR
        + '</td><td>' + element.BALANCE.toFixed(2)
        + '</td><td>' + element.NETSETT
        + '</td><td>' + element.TDS
        + '</td><td>' + element.DED
        + '</td><td>' + element.NARRATION
        + '</td></tr>';
      icounter += 1;
    });
    stringarr += '</table>';

    stringarr += '<div style="font-size: 9px;">Opening Balance:' + this.oAccLedgarMaster.LEDGER_OPN_BALANCE.toFixed(2) + ' Opening CR/DR : '
      + this.oAccLedgarMaster.OPEN_BALANCE_CRDR + ' Total Credit: ' + this.CreditAmpunt.toFixed(2)
      + ' Total Debit : ' + this.DebitAmpunt + ' Closing Amount : ' + (this.DebitAmpunt - this.CreditAmpunt).toFixed(2)
      + ' Closing CR/DR :' + (parseFloat((this.DebitAmpunt - this.CreditAmpunt).toString()) > 0 ? 'Dr' : 'Cr') + '  </div>';

    //var html = htmlToPdfmake('<div>   <h1>My title</h1>    <p>      This is a sentence with a <strong>bold word</strong>, <em>one in italic</em>,      and <u>one with underline</u>. And finally <a href="https://www.somewhere.com">a link</a>.    </p>  </div>');
    var html = htmlToPdfmake(stringarr);

    var docDefinition = {
      content: [
        html
      ],
      styles: {
        'html-strong': {
          background: 'yellow' // it will add a yellow background to all <STRONG> elements
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('PartyLedger.pdf');

  }
}


